<template>
    <ui-card class="ospi-number-card" v-if="cert">
        <div class="columns">
            <div class="column is-narrow">
                <i class="fad fa-certificate fa-2x has-text-primary"></i>
            </div>
            <div class="column">
        <div class="has-text-weight-bold is-size-5">OSPI Certificate Number</div>
        <div class="is-size-7 has-text-grey mb-4">The certificate number on your Washington teaching or paraeducator certificate, printed on your clock-hour forms.</div>

        <div class="columns">
            <div class="column is-5">
                <b-field label="OSPI Cert Number" label-position="inside">
                    <b-input v-model="number" placeholder="ie. 000000F" :disabled="!!cert.locked_at" @keyup.enter.native="save"></b-input>
                </b-field>
                <div class="is-size-7 has-text-grey" v-if="cert.locked_at">
                    <i class="fas fa-lock mr-2"></i>This number was confirmed by {{ cert.integration ? cert.integration.title : 'an integration' }}. <a href="mailto:support@my247ed.com">Contact support</a> if it needs to be changed.
                </div>
            </div>
        </div>

        <b-message type="is-warning" v-if="cert.conflicts">
            <i class="fas fa-exclamation-triangle mr-2"></i>This certificate number is in use by another account. Please verify it or <a href="mailto:support@my247ed.com">contact support</a>.
        </b-message>
            </div>
        </div>

        <template #footer>
            <div class="form-footer">
                <div class="is-size-7 has-text-grey">Other certifications and organization IDs live under <router-link :to="{name: 'account', params: {section: 'certs'}}">Certifications &amp; Organizations</router-link>.</div>
                <b-button type="is-primary" size="is-small" :disabled="!!cert.locked_at || saving || !dirty" :loading="saving" @click="save"><i class="fas fa-floppy-disk mr-2"></i>Save Changes</b-button>
            </div>
        </template>
    </ui-card>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import UiCard from "../UiCard";
    import {CLOCK_HOURS} from "../../store/modules/certifications";

    // The clock-hours certification number, edited from Professional
    // Development > Settings. Same save path as the Certifications &
    // Organizations switchboard (PUT app/users/certifications/1); the
    // switch itself stays on that page.
    export default {
        name: "OspiNumberCard",
        components: {UiCard},
        data() {
            return {number: '', saving: false};
        },
        computed: {
            ...mapGetters(['certificationById']),
            cert() {
                return this.certificationById(CLOCK_HOURS);
            },
            dirty() {
                return this.cert && (this.number || '') !== (this.cert.certification_number || '');
            }
        },
        methods: {
            ...mapActions(['saveCertification']),
            save() {
                if (!this.dirty || this.cert.locked_at) return;
                this.saving = true;
                this.saveCertification({
                    certification_id: this.cert.certification_id,
                    integration_id: this.cert.integration_id,
                    certification_number: this.number,
                }).then(() => {
                    this.$notify('success', 'Number Saved', 'Your OSPI certificate number has been saved.', {duration: 5000, permanent: false});
                }).catch(err => {
                    if (err.response && err.response.status === 409) {
                        this.$notify('error', 'Number Locked', 'This number is locked to your account. Please contact support to change it.', {duration: 8000, permanent: false});
                    } else {
                        this.$notify('error', 'Save Failed', 'Your change could not be saved. Please try again later.', {duration: 5000, permanent: false});
                    }
                }).finally(() => {
                    this.saving = false;
                });
            }
        },
        watch: {
            cert: {
                handler(c) {
                    this.number = (c && c.certification_number) || '';
                },
                immediate: true,
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        flex-wrap: wrap;
    }
</style>
